// extracted by mini-css-extract-plugin
export default {"container":"PathInfo_container__80ILM","icon":"PathInfo_icon__cHy11","popoverPrimary":"PathInfo_popoverPrimary__+8hR8","popoverSecondary":"PathInfo_popoverSecondary__mhJIK"};